import { jsxs as c, jsx as C } from "react/jsx-runtime";
const i = ({ size: r, className: l }) => /* @__PURE__ */ c(
  "svg",
  {
    className: l,
    fill: "none",
    height: r,
    viewBox: "0 0 20 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M18 9.26812C17.9606 9.51281 17.9362 9.76125 17.8791 10.0019C17.3197 12.3628 15.8666 13.8656 13.5212 14.5106C13.4409 14.5328 13.3581 14.5803 13.2994 14.6387C12.3431 15.5872 11.39 16.5384 10.4381 17.4916C10.2984 17.6312 10.1441 17.725 9.94063 17.6994C9.65094 17.6628 9.46656 17.4509 9.46344 17.1406C9.45813 16.6472 9.46156 16.1537 9.46156 15.6603C9.46156 15.4319 9.46156 15.2031 9.46156 14.9747C9.46156 14.6741 9.46156 14.675 9.15219 14.6737C8.63687 14.6719 8.12031 14.6906 7.60656 14.6619C5.51438 14.5453 3.92 13.5775 2.81906 11.8069C2.36 11.0681 2.1075 10.2537 2.03 9.38656C2.02656 9.34656 2.01031 9.3075 2 9.26781C2 8.97687 2 8.68562 2 8.39469C2.0425 8.14531 2.07844 7.89469 2.12844 7.64687C2.27938 6.89969 2.57625 6.21312 3.00437 5.5825C3.19687 5.29906 3.51531 5.22406 3.77594 5.39812C4.03562 5.57125 4.0925 5.89625 3.90344 6.17906C3.35281 7.00156 3.07594 7.90406 3.08625 8.89437C3.10812 10.9987 4.52156 12.845 6.55062 13.4175C6.98906 13.5412 7.43687 13.5969 7.89156 13.5981C8.56313 13.6 9.235 13.5978 9.90656 13.5991C10.3406 13.5997 10.5369 13.795 10.5381 14.2259C10.5394 14.6987 10.5384 15.1716 10.5384 15.6444C10.5384 15.7 10.5384 15.7556 10.5384 15.8594C10.6094 15.7919 10.6487 15.7556 10.6862 15.7181C11.3416 15.0644 11.9991 14.4125 12.6503 13.7544C12.7881 13.615 12.9441 13.5366 13.1328 13.4912C15.0134 13.0419 16.2456 11.8912 16.7594 10.0334C17.4856 7.40844 15.7119 4.645 13.0309 4.18062C12.7097 4.125 12.3797 4.09656 12.0538 4.09406C10.695 4.08469 9.33594 4.09281 7.97687 4.08906C7.17812 4.08687 6.41875 4.24375 5.70156 4.6025C5.35375 4.77656 5.00219 4.62812 4.9025 4.28031C4.83281 4.03656 4.9375 3.78594 5.17531 3.66281C5.87125 3.30156 6.61188 3.09281 7.39469 3.03344C7.48219 3.02688 7.56906 3.01125 7.65625 3C9.20844 3 10.7603 3 12.3125 3C12.3841 3.01031 12.4553 3.02031 12.5269 3.03062C12.8403 3.075 13.1584 3.09844 13.4663 3.16656C15.7272 3.6675 17.5141 5.54937 17.905 7.82969C17.9391 8.02812 17.9684 8.22719 17.9997 8.42625V9.26812H18Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "circle",
        {
          cx: "7.05421",
          cy: "8.97334",
          fill: "currentColor",
          r: "0.459487"
        }
      ),
      /* @__PURE__ */ C(
        "circle",
        {
          cx: "9.81105",
          cy: "8.97333",
          fill: "currentColor",
          r: "0.459487"
        }
      ),
      /* @__PURE__ */ C(
        "circle",
        {
          cx: "12.5679",
          cy: "8.97333",
          fill: "currentColor",
          r: "0.459487"
        }
      )
    ]
  }
);
export {
  i as ForumV2
};
